export default {
    getFoodIcon(icon) {
        return {
            table: require('../../utilities/img/table.svg'),
            pickUpBar: require('../../utilities/img/pickUpBar.svg'),
            pickUpChiringuito: require('../../utilities/img/pickUpChiringuito.svg'),
            delivery: require('../../utilities/img/local_shipping.svg'),
            beachUmbrella: require('../../utilities/img/beachUmbrella.svg'),
            beachUmbrellaWithCover: require('../../utilities/img/beachUmbrellaWithCover.svg'),
            hotel: require('../../utilities/img/hotel.svg'),
            // Markers
            markerFood: require('../../../world/libs/anm22_icons/img/markers/marker-food.png'),
            markerBar: require('../../../world/libs/anm22_icons/img/markers/marker-bar.png'),
            markerRestaurant: require('../../../world/libs/anm22_icons/img/markers/marker-restaurant.png'),
        }[icon];
    }
}